var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{ref:"map",staticClass:"map",attrs:{"id":"map"}}),_c('div',{directives:[{name:"download",rawName:"v-download",value:({
      url: _vm.downloadFile.path,
      fileName: _vm.downloadFile.fileName
    }),expression:"{\n      url: downloadFile.path,\n      fileName: downloadFile.fileName\n    }"}],staticClass:"btn_downloadFile flex-ct"},[_vm._v(" 点击下载指南手册 ")]),_c('NavigatorBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }